const SriLankaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_112439)">
      <path
        d="M20 39.9999C31.0456 39.9999 39.9999 31.0456 39.9999 20C39.9999 8.95429 31.0456 0 20 0C8.95429 0 0 8.95429 0 20C0 31.0456 8.95429 39.9999 20 39.9999Z"
        fill="#FFDA44"
      />
      <path
        d="M15.6517 3.47852H8.72706C8.42018 3.68828 8.11987 3.90664 7.82557 4.13266L6.08643 20.0002L7.82557 35.8677C8.11987 36.0938 8.42018 36.3122 8.72706 36.5219H15.6517V3.47852Z"
        fill="#FF9811"
      />
      <path
        d="M0 19.9994C0 26.4639 3.06782 32.211 7.82611 35.867V4.13184C3.06782 7.78794 0 13.535 0 19.9994Z"
        fill="#6DA544"
      />
      <path d="M32.1743 12.1924V12.6928L32.1929 12.6956L32.1743 12.1924Z" fill="#FFDA44" />
      <path
        d="M38.4057 25.2176H34.6375L33.0433 26.9568V30.4351H29.5651V28.6959H31.3042V25.2176H23.4781V27.3915H21.739V23.2485C21.2054 22.7708 20.8694 22.077 20.8694 21.3046V10.0002C20.8694 8.55954 22.0374 7.39157 23.4781 7.39157V23.4786H26.9564L28.1498 22.4839C27.9414 21.9875 27.8259 21.4422 27.8259 20.8699V18.2612H25.2172V13.0438H30.4346C30.4346 12.1743 31.739 11.3047 31.739 11.3047C31.739 11.3047 33.0433 12.1742 33.0433 13.0438V14.3482V18.2613C34.0108 18.2728 35.5478 18.2477 37.2084 18.2613C36.7721 17.4988 36.5216 16.594 36.5216 15.6526C36.5216 14.1181 37.1841 12.7386 38.2386 11.7839C36.7186 8.41556 34.2931 5.54352 31.2723 3.47852H18.2607V36.522H31.2723C34.9457 34.011 37.7386 30.307 39.0936 25.9681L38.4057 25.2176Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112439">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SriLankaSvg;
